import React from "react";
import "./WebCheckin.css";
import images from "../../../Utils/importImages";
import "./TicketView.css";
import DefaultAirlineImage from "../../../Assets/Images/default-airline.png";

function WebCheckin({ links, Data, onClose }) {
  console.log("links , data is : ", links, Data);

  return (
    <div className="web-checkin-popup">
      <div className="header">
        <div className="heading proxima_semibold font18 color_black">
          Web Checkin
        </div>
        <img
          src={images["cross-icon-pop.svg"]}
          alt=""
          srcset=""
          onClick={() => onClose()}
        />
      </div>
      <div className="air-ticket-view proxima_regular">
        <div className="ticket-view-wrapper web-checkin">
          {Data.Data.map((itemm, id) => {
            return (
              <div className="ticket--data--internal" key={id}>
                <div className="ticket--head--userdb">
                  <div className="ticket--head--data--left">
                    <div className="ticket--onward-return--timings">
                      <div className="ticket--onward--return proxima_regular">
                        {itemm.mainHeading.heading}
                      </div>
                    </div>
                    <div className="ticket--subflight--details">
                      {itemm.mainHeading.Data.map((item) => (
                        <div
                          className="route--row"
                          style={{ paddingTop: "5px" }}
                        >
                          <div className="left--route--row">
                            <div className="route--row--source">
                              {item.From}
                            </div>
                            <div className="route--row--stops proxima_regular">
                              {item?.Stops ||
                                `${
                                  itemm.WrappedData.length - 1 == 0
                                    ? "Non"
                                    : itemm.WrappedData.length - 1
                                } Stop${
                                  itemm.WrappedData.length - 1 > 1 ? "s" : ""
                                }`}
                            </div>
                            <div className="route--row--source">{item.To}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="ticketContent--userdb web-checkin">
                  {itemm.WrappedData.map((item, id) => {
                    return (
                      <>
                        <div className="web-chekin-content">
                          <div className="content-info">
                            <div className="airline-content">
                              <div className="segment--airline-logo">
                                <img
                                  src={
                                    item.AirlineLogo == "UnKnown"
                                      ? DefaultAirlineImage
                                      : item.AirlineLogo
                                  }
                                  alt=""
                                />
                              </div>
                              <div className="segment--airline-info">
                                <div className="segment--airline-name proxima_semibold">
                                  {item.AirlineName}
                                  {" , "}
                                  <span className="proxima_regular font12">
                                    {item.AirlineCodeName}
                                  </span>
                                </div>
                              </div>
                            </div>

                            <div className="airline-content">
                              <div
                                style={{
                                  width: "1px",
                                  height: "12px",
                                  backgroundColor: "#001446",
                                }}
                              ></div>
                            </div>

                            <div className="airports">
                              <div className="segment--route-name">
                                {item.FromData.Text1}
                              </div>

                              <div className="segment--route-name">
                                <img
                                  src={images["forward-arrow-dull.svg"]}
                                  alt=""
                                  srcset=""
                                />
                              </div>

                              <div className="segment--route-name">
                                {item.ToData.Text1}
                              </div>
                            </div>
                          </div>
                          <div className="content-control proxima_semibold color_white">
                            <a
                              href={
                                links[item.AirlineCodeName.split(" ")[0] ?? ""]
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              GO <img src={images["checkin-logo.svg"]} alt="" />
                            </a>
                          </div>
                        </div>
                      </>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default WebCheckin;
